export default {
  key: 'kta',
  visibleComponents: {
    footer: {
      links: false
    },
    features: {
    },
    navigation: {
      topics: false,
      statistic: false,
      publications: false,
      kba: false,
      search: false,
      hearing: false,
      accessibility: false
    }
  }
}
